import { render, staticRenderFns } from "./TeacherForm.vue?vue&type=template&id=ebe6355c&scoped=true&"
import script from "./TeacherForm.vue?vue&type=script&lang=ts&"
export * from "./TeacherForm.vue?vue&type=script&lang=ts&"
import style0 from "./TeacherForm.vue?vue&type=style&index=0&id=ebe6355c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebe6355c",
  null
  
)

export default component.exports